import axios from "axios";
import { coreApi, endPoints } from "../config/clinimentApi";
import { ClinimentAuth } from "./ClinimentAuth";
import errorHandling from "./ErrorHandling";
import Cookies from "js-cookie";
import { ClinimentFunctions } from "./ClinimentFunctions";

const Login = {
  userLogin: async (data) => {
    try {
      const response = await ClinimentAuth.fetchData(
        coreApi + endPoints.login,
        "post",
        { "client-platform": "web" },
        data
      );
      Cookies.set("authToken", response?.data?.tokens?.access?.token);
      Cookies.set("userRoles", response?.data?.user?.roles);
      Cookies.set("userId", response.data.user.id);
      // Cookies.set("path", ClinimentFunctions.getUserAccess(response.data.user.roles));
      Cookies.set("path", "patients/patients");
      return response;
    } catch (err) {
      errorHandling.handleErrors(
        err,
        err.response && err.response.status ? err.response.status : "500"
      );
    }
  },

  loginSSO: async (data) => {
    try {
      const response = await axios.post(endPoints.loginSSOUrl, data, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY
        }
      });
      Cookies.set("authToken", response.data.token);

      Cookies.set("userRoles", response.data.user.roles);
      Cookies.set("userId", response.data.user.sk_user_id);

      Cookies.set("path", ClinimentFunctions.getUserAccess(response.data.user.role));
      return response;
    } catch (err) {
      return err.response.data;
    }
  },

  requestPhoneOtp: async (data) => {
    try {
      const response = await ClinimentAuth.fetchData(
        coreApi + endPoints.requestPhoneOtp,
        "post",
        { "client-platform": "web" },
        data
      );
      return response;
    } catch (err) {
      errorHandling.handleErrors(err, err?.response?.data?.message || err?.message);
    }
  },

  verifyPhoneOtp: async (data) => {
    try {
      const response = await ClinimentAuth.fetchData(
        coreApi + endPoints.verifyPhoneOtp,
        "post",
        { "client-platform": "web" },
        data
      );
      Cookies.set("authToken", response?.data?.tokens?.access?.token);
      Cookies.set("userRoles", response?.data?.user?.roles);
      Cookies.set("userId", response.data.user.id);
      // Cookies.set("path", ClinimentFunctions.getUserAccess(response.data.user.roles));
      Cookies.set("path", "patients/patients");
      return response;
    } catch (err) {
      errorHandling.handleErrors(err, err?.response?.data?.message || err?.message);
    }
  }
};
export default Login;
